import { Injectable } from '@angular/core';
import { AppInitService } from './app-init.service';
import { StorageService } from './storage.service';
import { UserErrorHandlerService } from './user-error-handler.service';
import { MessageInfoVersionService } from './message-info-version.service';
import { NetworkStatusService } from './network-status.service';
import { ConfigService } from './config.service';

import { NavigationService } from './navigation.service';
import { OffersService } from './offers.service';
import { StudentService } from './student.service';
import { StatsService } from './stats.service';
import { AdjustService } from './adjust.service';
import { CdrVersionService } from './cdr-version.service';
import { StudentFeatureFlagsService } from './student-feature-flags.service';
import { GamificationService } from './gamification.service';
import { ConfigUserService } from './config-user.service';
import { KameleoonService } from './kameleoon.service';
import { ReserverLeconService } from './reserver-lecon.service';
import { SessionsService } from './sessions.service';
import { AnswersService } from './answers.service';
import { SeriesService } from './series.service';
import { SyncCDRService } from './sync-cdr.service';
import { UserSessionService } from './user-session.service';
import { KameleoonFeatureFlagsService } from './kameleoon-feature-flags.service';
import { StudentDocumentsService } from './student-documents.service';

@Injectable({ providedIn: 'root' })
export class InitializationService {
  private registered = false;

  constructor(
    private appInitService: AppInitService,
    private messageInfoVersionService: MessageInfoVersionService,
    private networkStatusService: NetworkStatusService,
    private storageService: StorageService,
    private userErrorHandlerService: UserErrorHandlerService,
    private configService: ConfigService,

    private navigationService: NavigationService,
    private offerService: OffersService,
    private studentService: StudentService,
    private statsService: StatsService,
    private adjustService: AdjustService,
    private cdrVersionService: CdrVersionService,
    private studentFeatureFlagsService: StudentFeatureFlagsService,
    private gamificationService: GamificationService,
    private configUserService: ConfigUserService,
    private kameleoonService: KameleoonService,
    private reserverLeconService: ReserverLeconService,
    private sessionService: SessionsService,
    private answersService: AnswersService,
    private seriesService: SeriesService,
    private syncCDRService: SyncCDRService,
    private userSessionService: UserSessionService,
    private kameleoonFeatureFlagsService: KameleoonFeatureFlagsService,
    private studentDocumentsService: StudentDocumentsService
  ) {}

  registerServices() {
    if (this.registered) return;
    this.registered = true;
    this.appInitService.register('init0', this.messageInfoVersionService);
    this.appInitService.register('init0', this.networkStatusService);
    this.appInitService.register('init0', this.storageService);
    this.appInitService.register('init0', this.userErrorHandlerService);

    this.appInitService.register('init1', this.configService);
    this.appInitService.register('init1', this.kameleoonFeatureFlagsService);

    this.appInitService.register('init2', this.navigationService);
    this.appInitService.register('init2', this.offerService);
    this.appInitService.register('init2', this.studentService);

    this.appInitService.register('init3', this.cdrVersionService);
    this.appInitService.register('init3', this.studentFeatureFlagsService);
    this.appInitService.register('init3', this.gamificationService);
    this.appInitService.register('init3', this.configUserService);
    this.appInitService.register('init3', this.kameleoonService);
    this.appInitService.register('init3', this.reserverLeconService);
    this.appInitService.register('init3', this.studentDocumentsService);

    this.appInitService.register('init4', this.statsService);
    this.appInitService.register('init4', this.sessionService);
    this.appInitService.register('init4', this.answersService);

    this.appInitService.register('init5', this.adjustService);
    this.appInitService.register('init5', this.seriesService);
    this.appInitService.register('init5', this.syncCDRService);
    this.appInitService.register('init5', this.userSessionService);
  }
}
